import styled from 'styled-components'
import { Box } from '@mrshmllw/smores-react'

import { FIELD_CONTROL_MAX_WIDTH } from 'directFlow/constants'

export const FieldList = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 56px;

  width: 100%;
  max-width: 630px;
`

export const InputContainer = styled(Box)`
  @media (min-width: 768px) {
    max-width: ${FIELD_CONTROL_MAX_WIDTH}px;
  }
`
